export const educationData = [
    //{
        // id: 1,
        // institution: 'Kianyaga High',
        // course: 'Higher Secondary Education',
        // startYear: '2007',
        // endYear: '2013'
    //},
    {
        id: 2,
        institution: 'Jomo Kenyatta University of Agriculture and Technology',
        course: 'Bachelor of Information Technology',
        startYear: '2014',
        endYear: '2018'
    },
    //{
        // id: 3,
        // institution: 'Hawking University, Cambridge',
        // course: 'Master of Technology',
        // startYear: '2019',
        // endYear: 'Present'
    //}
]